export function range(
  startInclusive: number,
  endExclusive: number,
): Array<number> {
  return Array.from(Array(endExclusive - startInclusive).keys()).map(
    (i) => i + startInclusive,
  );
}

export function rangeClosed(
  startInclusive: number,
  endInclusive: number,
): Array<number> {
  return Array.from(Array(endInclusive - startInclusive + 1).keys()).map(
    (i) => i + startInclusive,
  );
}
